

import type { StructureLayoutType } from '@/lib/types';

/**
 * Layout type mapping from template ID to layout type
 */
export const TEMPLATE_LAYOUTS: Record<string, StructureLayoutType> = {
  'heros-journey': 'circular',
  'kishotenketsu': 'linear',
  'fichtean-curve': 'curve',
  'three-act': 'linear',
  'custom': 'grid',
};

/**
 * Status color configuration for nodes
 */
export const STATUS_COLORS = {
  complete: { primary: '#10b981', bg: '#10b98115', text: '#059669' },
  partial: { primary: '#f59e0b', bg: '#f59e0b15', text: '#d97706' },
  notWritten: { primary: '#6b7280', bg: '#6b728015', text: '#4b5563' },
} as const;

export type StatusType = keyof typeof STATUS_COLORS;
